module.exports = __webpack_public_path__ + "static/img/sf-item-06.4e3e9bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-06.png
// module id = 13uQ
// module chunks = 2